<div class="user-corner-popup__triangle"></div>

<div class="user-corner-popup__container">
  <div class="user-corner-popup__container-item" (click)="onSettingsClick()">
    <i class="fa fa-wrench" aria-hidden="true"></i> Settings
  </div>

  <div class="user-corner-popup__container-item" (click)="onLogoutClick()">
    <i class="fa fa-sign-out" aria-hidden="true"></i> Logout
  </div>
</div>
